import get from 'lodash/get';

export const getMessage = state => get( state, 'message.message', '' );
export const getSelectedEcard = state => get( state, 'message.selectedEcard' );
export const getPrivate = state => get( state, 'message.private', false );
